export const getters = {
  getModalViewPRoduct: state => state.modalViewProduct,
  getProducts: state => state.products,
  getProduct: state => state.product,
  getMarkedProducts: state => state.markedProducts
};

export default {};
